import React from 'react';
import { motion } from 'framer-motion';
import { LoginForm } from './LoginForm';
import { Button } from './ui/Button';
import { CheckCircle2, MapPin, Award } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full bg-gradient-to-br from-brand-purple-50 via-white to-brand-orange-50 pt-32 pb-16 lg:pt-40 lg:pb-24 overflow-hidden" data-id="element-112">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 -translate-y-1/4 translate-x-1/4 w-96 h-96 bg-brand-purple-100 rounded-full blur-3xl opacity-50 pointer-events-none" data-id="element-113" />
      <div className="absolute bottom-0 left-0 translate-y-1/4 -translate-x-1/4 w-96 h-96 bg-brand-orange-100 rounded-full blur-3xl opacity-50 pointer-events-none" data-id="element-114" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative" data-id="element-115">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center" data-id="element-116">
          {/* Left Content */}
          <motion.div className="lg:col-span-7 space-y-8 text-center lg:text-left" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-117">
            <div className="space-y-4" data-id="element-118">
              <div className="inline-flex items-center px-3 py-1 rounded-full bg-brand-purple-100 text-brand-purple-800 text-sm font-medium mx-auto lg:mx-0" data-id="element-119">
                <MapPin className="w-4 h-4 mr-1.5" data-id="element-120" />
                Arizona's Premier Real Estate School
              </div>

              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 tracking-tight leading-tight" data-id="element-121">
                Arizona Real Estate <br className="hidden lg:block" data-id="element-122" />
                <span className="text-brand-purple-600" data-id="element-123">License Renewal</span>
              </h1>

              <p className="text-xl sm:text-2xl text-gray-600 font-medium" data-id="element-124">
                Continuing Education Made Easy
              </p>

              <p className="text-lg text-gray-500 max-w-2xl mx-auto lg:mx-0" data-id="element-125">
                Online, Zoom, and Live CE Classes — Built specifically for
                Arizona Agents. Get your credits quickly and conveniently.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-126">
              <Button size="lg" className="shadow-lg shadow-brand-purple-200" data-id="element-127">
                View Classes
              </Button>
              <Button variant="outline" size="lg" data-id="element-128">
                See Schedule
              </Button>
            </div>

            {/* Trust Signals */}
            <div className="pt-4 flex flex-wrap justify-center lg:justify-start gap-x-8 gap-y-4 text-sm text-gray-500" data-id="element-129">
              <div className="flex items-center" data-id="element-130">
                <CheckCircle2 className="w-4 h-4 text-green-500 mr-2" data-id="element-131" />
                ADRE School #S06-0002
              </div>
              <div className="flex items-center" data-id="element-132">
                <Award className="w-4 h-4 text-brand-orange-500 mr-2" data-id="element-133" />
                REEA Member
              </div>
              <div className="flex items-center" data-id="element-134">
                <MapPin className="w-4 h-4 text-brand-purple-500 mr-2" data-id="element-135" />
                Locally Owned & Operated
              </div>
            </div>
          </motion.div>

          {/* Right Content - Login Form */}
          <motion.div className="lg:col-span-5 w-full" initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-136">
            <LoginForm data-id="element-137" />
          </motion.div>
        </div>
      </div>
    </section>;
}